import { ComponentStyle } from '../../../models';
import { AccordionPanelConfig } from './accordion-panel-config';

export class AccordionPanelBuilder {
  isOpen: boolean;
  style: ComponentStyle;
  disabled: boolean;

  static panel() {
    return new AccordionPanelBuilder();
  }

  withOpen(isOpen = true): AccordionPanelBuilder {
    this.isOpen = isOpen;
    return this;
  }

  withStyle(style = ComponentStyle.Default): AccordionPanelBuilder {
    this.style = style;
    return this;
  }

  withDisabled(disabled = true): AccordionPanelBuilder {
    this.disabled = disabled;
    return this;
  }

  build(): AccordionPanelConfig {
    return new AccordionPanelConfig({
      isOpen: this.isOpen,
      style: this.style,
      disabled: this.disabled
    });
  }
}
